// export const BASE_URL = 'http://113.250.189.120:8037'
// export const BASE_URL = 'http://192.168.0.105:8031'
// export const BASE_URL = 'https://www.huiwuyuntong.com/water-drinking-beta'
export const BASE_URL = 'http://192.168.0.200:8037'